export const isApprovalDateRangeValid = (fromDate = "", toDate = "") => {
  const hasFrom = Boolean(String(fromDate).trim());
  const hasTo = Boolean(String(toDate).trim());
  return (hasFrom && hasTo) || (!hasFrom && !hasTo);
};

export const hasCompleteApprovalDateRange = (fromDate = "", toDate = "") => {
  return Boolean(String(fromDate).trim()) && Boolean(String(toDate).trim());
};
